import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import { FilterProps } from 'react-table';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ButtonIcon } from '../../button-icon';

const DATE_PICKER_FORMAT = 'yyyy-MM-dd';
const infinityDate: Date = new Date(9999, 1, 1);
const minusInfinityDate: Date = new Date(111, 1, 1);

function CalendarTrigger(props: any) {
  const { onClick, value, text, handleClear } = props;
  return (
    <div style={{ position: 'relative' }}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
      <span onClick={onClick} style={{ cursor: 'pointer', color: value ? '#007298' : '#676e71' }}>
        {text}
      </span>
      {value && (
        <ButtonIcon
          style={{ position: 'absolute', top: '-1px', color: '#007298' }}
          icon={faTrash}
          size="xs"
          onClick={handleClear}
          tooltip={value}
        />
      )}
    </div>
  );
}

export function TableDateTimeFilter({ setAllFilters, state: { filters }, column }: FilterProps<any>) {
  let minDate: Date;
  let endDate: Date;
  const { t } = useTranslation();

  const currentColumnFilters = filters.filter((filter) => filter.id === column.id);
  if (currentColumnFilters.length === 2) {
    [minDate, endDate] = currentColumnFilters.map((filter) => moment(filter.value).toDate()).sort((a, b) => a.getTime() - b.getTime());
  } else {
    [minDate, endDate] = [minusInfinityDate, infinityDate];
  }

  const updateFilters = (newMinDate: Date, newEndDate: Date) => {
    const allOtherColumnFilters = filters.filter((filter) => filter.id !== column.id);
    // if both min and end dates were unset we remove totally the filters to go to the initial pritine state.

    if (
      newMinDate &&
      newEndDate &&
      newMinDate.getTime() === minusInfinityDate.getTime() &&
      newEndDate.getTime() === infinityDate.getTime()
    ) {
      setAllFilters(allOtherColumnFilters);
    } else {
      setAllFilters([
        ...allOtherColumnFilters,
        {
          id: column.id,
          value: newMinDate.toJSON(),
        },
        {
          id: column.id,
          value: newEndDate.toJSON(),
        },
      ]);
    }
  };

  return (
    <Row className="table-dates-filter-wrapper px-0" style={{ marginLeft: 0, marginRight: 0, height: '2.6rem' }}>
      <Col md={6} className="px-0">
        <DatePicker
          selected={minDate.getTime() !== minusInfinityDate.getTime() ? minDate : null}
          dateFormat={DATE_PICKER_FORMAT}
          selectsStart={true}
          endDate={endDate.getTime() !== infinityDate.getTime() ? endDate : null}
          onChange={(value) => {
            const newMinDateValue = value && !Array.isArray(value) && moment(value).isValid() ? value : minusInfinityDate;
            updateFilters(newMinDateValue, endDate);
          }}
          customInput={<CalendarTrigger text={t('table.filter.from')} handleClear={() => updateFilters(minusInfinityDate, endDate)} />}
        />
      </Col>
      <Col md={6} className="px-0">
        <DatePicker
          selected={endDate.getTime() !== infinityDate.getTime() ? endDate : null}
          dateFormat={DATE_PICKER_FORMAT}
          selectsEnd={true}
          minDate={minDate.getTime() !== minusInfinityDate.getTime() ? minDate : undefined}
          onChange={(value) => {
            const newEndDateValue = value && !Array.isArray(value) && moment(value).isValid() ? value : infinityDate;
            updateFilters(minDate, newEndDateValue);
          }}
          customInput={<CalendarTrigger text={t('table.filter.to')} handleClear={() => updateFilters(minDate, infinityDate)} />}
        />
      </Col>
    </Row>
  );
}
